function collectFromPanelRows(panelRows: unknown, out: Set<number>): void {
  if (!Array.isArray(panelRows)) return
  for (const row of panelRows) {
    if (!Array.isArray(row)) continue
    for (const cell of row) {
      if (!cell || typeof cell !== 'object') continue
      const panelId = Number((cell as { panelId?: unknown }).panelId)
      if (Number.isFinite(panelId) && panelId > 0) {
        out.add(panelId)
      }
    }
  }
}

function collectFromRegion(region: unknown, out: Set<number>): void {
  if (!Array.isArray(region)) return
  for (const band of region) {
    if (!Array.isArray(band)) continue
    for (const tab of band) {
      if (!tab || typeof tab !== 'object') continue
      collectFromPanelRows((tab as { panelRows?: unknown }).panelRows, out)
    }
  }
}

/** panelId из main/header/footer после parseService.getForm. */
export function collectLayoutPanelIds(formLike: unknown): number[] {
  if (!formLike || typeof formLike !== 'object') {
    return []
  }
  const form = formLike as Record<string, unknown>
  const ids = new Set<number>()
  for (const key of ['main', 'header', 'footer'] as const) {
    collectFromRegion(form[key], ids)
  }
  return [...ids]
}

function addPanelId(ids: Set<string>, value: unknown): void {
  const id = String(value ?? '').trim()
  if (id) ids.add(id)
}

function collectPanelIdsFromMap(panels: unknown, ids: Set<string>): void {
  if (!panels || typeof panels !== 'object' || Array.isArray(panels)) return
  for (const [key, panel] of Object.entries(panels as Record<string, unknown>)) {
    addPanelId(ids, key)
    if (!panel || typeof panel !== 'object') continue
    const record = panel as Record<string, unknown>
    const attrs = record._attributes as { id?: unknown } | undefined
    addPanelId(ids, record.panelId)
    addPanelId(ids, record.id)
    addPanelId(ids, attrs?.id)
  }
}

/**
 * Panel ids defined by the parsed form (`panels` map).
 * null when the layout is not parsed yet — callers must not treat that as "no panels".
 */
export function parsedFormPanelIds(formLike: unknown): Set<string> | null {
  if (!formLike || typeof formLike !== 'object') return null
  const root = formLike as Record<string, unknown>
  const ids = new Set<string>()
  collectPanelIdsFromMap(root.panels, ids)
  const nested = root.form
  if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
    collectPanelIdsFromMap((nested as Record<string, unknown>).panels, ids)
  }
  return ids.size > 0 ? ids : null
}
